import { EditableImg, EditableText } from '@smartfire/components';
import { useEditor } from '@smartfire/js-block-engine';
import style from './index.module.scss';
import { ReactComponent as LinkedInLogo } from './LinkedIn_Logo.svg';
import { useMediaQuery } from '@material-ui/core';

function ContactInfos({ tel, linkLinkedin }) {
    const { isEditing } = useEditor();
    const isDesktop = useMediaQuery(`(min-width : calc(${style.tabletBreakpoint} + 1px))`);
    return (
        <div className={style.container}>
            <p className={style.helpText}>{"Besoin d'aide ?"}</p>
            <a className={style.tel} href={!isEditing && `tel:${tel.replace(/\(.\)/g, '')}`}>
                {tel}
            </a>
            <EditableText tagName={'p'} placeholder={'Horaires'} smartProp={'openings'} className={style.openings} />
            <p>Suivez-nous :</p>
            <a href={!isEditing && linkLinkedin} target="_blank" rel="noreferrer" className={style.linkedin}>
                <LinkedInLogo />
            </a>
            {isDesktop && (
                <>
                    <p>Nos certifications :</p>
                    <EditableImg smartProp={'certifications'} className={style.logos} />
                </>
            )}
        </div>
    );
}

export default ContactInfos;
